import { Component, inject } from '@angular/core';
import { CustomerService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CustomerCreateDto,
  CustomerDto,
  CustomerExcelDownloadDto,
  CustomerUpdateDto,
} from '../proxy/controlling/dtos/customer';
import { CUSTOMER_CONFIG, CUSTOMER_FIELDS } from './customer.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-customer',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CustomerService, ConfirmationService],
  templateUrl: './customer.html',
  styleUrl: './customer.scss',
})
export class Customer extends BaseCrudComponent<
  CustomerDto,
  CustomerCreateDto,
  CustomerUpdateDto,
  CustomerExcelDownloadDto
> {
  service = inject(CustomerService);
  config = CUSTOMER_CONFIG;
  fields = CUSTOMER_FIELDS;

  protected prepareUpdateDto(data: any, selected: CustomerDto): CustomerUpdateDto {
    return {
      sapCode: data.sapCode,
      name: data.name,
      vatNumber: data.vatNumber,
      termsOfPayments: data.termsOfPayments,
      reconAccount: data.reconAccount,
      isGenericCustomer: data.isGenericCustomer,
      isOwnService: data.isOwnService,
      searchTerm: data.searchTerm,
      businessArea: data.businessArea,
      languageKey: data.languageKey,
      vendor: data.vendor,
      isNaturalPerson: data.isNaturalPerson,
      locationNumber: data.locationNumber,
      oldSapCode: data.oldSapCode,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Customer';
  }
}
